module.exports = __webpack_public_path__ + "static/media/Maps-Early-Detail.c9ec3eeb.jpg";